import { render, staticRenderFns } from "./restFacilities.vue?vue&type=template&id=eeb52a42"
import script from "./restFacilities.vue?vue&type=script&lang=js"
export * from "./restFacilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb52a42')) {
      api.createRecord('eeb52a42', component.options)
    } else {
      api.reload('eeb52a42', component.options)
    }
    module.hot.accept("./restFacilities.vue?vue&type=template&id=eeb52a42", function () {
      api.rerender('eeb52a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rtf/restFacilities.vue"
export default component.exports